module.exports = __webpack_public_path__ + "static/media/beach.4a9a3540.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/ActivityBadge/icons/beach.svg
// module id = 292
// module chunks = 0